// @ts-nocheck
import { CountryCodeInputProps } from "./CountryCodeInput.types";
import {
  CountryCodeWrapper,
  ChevronDropdownIcon,
  PhoneInputStyled,
} from "./CountryCodeInput.styles";
import { APPROVED_COUNTRY_ISO_CODES } from "utils/approvedCountries";

export const CountryCodeInput = (props: CountryCodeInputProps) => {
  const {
    countryCode,
    international = true,
    countryCallingCodeEditable = false,
    defaultCountry = "IN",
    smartCaret = false,
    readOnly = true,
    width = "fitContent",
    height = "100%",
    variant = "default",
    countries = APPROVED_COUNTRY_ISO_CODES,
    onChange = () => {},
  } = props;

  return (
    <CountryCodeWrapper variant={variant} height={height}>
      <PhoneInputStyled
        international={international}
        countryCallingCodeEditable={countryCallingCodeEditable}
        defaultCountry={defaultCountry}
        placeholder="Enter phone number"
        value={countryCode}
        smartCaret={smartCaret}
        readOnly={readOnly}
        disabled={false}
        width={width}
        countries={countries}
        onChange={onChange}
        className="phone-input"
      />
      <ChevronDropdownIcon className="fa-solid fa-caret-down"></ChevronDropdownIcon>
    </CountryCodeWrapper>
  );
};
